import React from "react";
import { Product } from "../../../Interfaces/Product";
import "./UpdateInventoryPendingDisplay.css";
import {
  InventoryStockUpdate,
  INVENTORY_UPDATE_REASON_OPTIONS,
  InventoryUpdateReason,
} from "../../../Interfaces/Warehouse";

interface UpdateInventoryPendingDisplayProps {
  products: Product[];
  updateInventoryStock: InventoryStockUpdate[];
  setUpdateInventoryStock: React.Dispatch<
    React.SetStateAction<InventoryStockUpdate[]>
  >;
}

const UpdateInventoryPendingDisplay: React.FC<
  UpdateInventoryPendingDisplayProps
> = ({ products, updateInventoryStock, setUpdateInventoryStock }) => {
  const reversedList = [...updateInventoryStock].reverse();
  return (
    <div className="update-inventory-sku-quantity-list">
      <h3>Product Update List</h3>
      <ul>
        {reversedList.map((item, index) => {
          const product = products.find((p) => p.sku === item.product);

          const actualIndex = updateInventoryStock.length - 1 - index;

          const handleDelete = () => {
            setUpdateInventoryStock((prevList) =>
              prevList.filter((_, i) => i !== actualIndex)
            );
          };
          return (
            <li key={index} className="update-inventory-sku-quantity-item">
              {/* TOP ROW */}
              <div className="update-inventory-top-row">
                <img
                  src={product?.image_url || ""}
                  alt={product?.item_display_name}
                />

                <div className="update-inventory-sku">{item.product}</div>
                <div className="update-inventory-product-name">
                  {product?.item_display_name}
                </div>

                <div className="update-inventory-qty">
                  <label htmlFor={`qty-input-${index}`}>Qty:</label>
                  <input
                    id={`qty-input-${index}`}
                    type="number"
                    value={item.increment}
                    onChange={(e) => {
                      const newQty = parseInt(e.target.value, 10) || 0;
                      setUpdateInventoryStock((prevList) =>
                        prevList.map((skuItem, i) =>
                          i === actualIndex
                            ? { ...skuItem, increment: newQty }
                            : skuItem
                        )
                      );
                    }}
                  />
                </div>

                <div className="update-inventory-reasoning">
                  <label htmlFor={`reasoning-input-${index}`}>Reason:</label>
                  <select
                    id={`reasoning-input-${index}`}
                    value={item.reason}
                    onChange={(e) =>
                      setUpdateInventoryStock((prevList) =>
                        prevList.map((skuItem, i) =>
                          i === actualIndex
                            ? {
                                ...skuItem,
                                reason: e.target.value as InventoryUpdateReason,
                              }
                            : skuItem
                        )
                      )
                    }
                  >
                    {Object.values(INVENTORY_UPDATE_REASON_OPTIONS).map(
                      (reason) => (
                        <option key={reason.label} value={reason.value}>
                          {reason.label}
                        </option>
                      )
                    )}
                  </select>
                </div>

                <div
                  className="update-inventory-delete-btn"
                  onClick={handleDelete}
                >
                  &times;
                </div>
              </div>

              {/* BOTTOM ROW */}
              {item.reason_detail && (
                <div className="update-inventory-bottom-row">
                  <label htmlFor={`reasoning-detail-${index}`}>
                    Reason Detail:
                  </label>
                  <textarea
                    id={`reasoning-detail-${index}`}
                    value={item.reason_detail}
                    onChange={(e) =>
                      setUpdateInventoryStock((prevList) =>
                        prevList.map((skuItem, i) =>
                          i === actualIndex
                            ? { ...skuItem, reason_detail: e.target.value }
                            : skuItem
                        )
                      )
                    }
                    rows={2}
                  />
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
export default UpdateInventoryPendingDisplay;
